/* Shoppe Meister quick-view: fetch fully Shopify-rendered Liquid form, never open an empty dialog. */
(() => {
  const dialog = document.getElementById('sm-quick-view-dialog');
  const body = document.getElementById('sm-quick-view-body');
  if (!dialog || !body) return;
  const cache = new Map();
  let controller;
  let requestId = 0;

  const safeProductPath = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname) ? url : null;
    } catch { return null; }
  };

  const showFallback = (url) => {
    body.replaceChildren();
    const message = document.createElement('p');
    message.className = 'sm-qv__error';
    message.textContent = 'We could not load the quick view. You can still see all product details.';
    const link = document.createElement('a');
    link.href = url.href;
    link.textContent = 'Open product page →';
    link.className = 'sm-qv__view';
    body.append(message, link);
    dialog.setAttribute('aria-label', 'Product details');
  };

  async function openQuickView(rawUrl) {
    const productUrl = safeProductPath(rawUrl);
    if (!productUrl) return;
    controller?.abort();
    controller = new AbortController();
    const seq = ++requestId;
    body.replaceChildren();
    const status = document.createElement('p');
    status.className = 'sm-qv__loading';
    status.textContent = 'Loading product details…';
    body.append(status);
    if (!dialog.open) dialog.showModal();
    try {
      const sectionUrl = new URL(productUrl.href);
      // Keep Shopify's unpublished-theme preview context when previewing a new ZIP.
      const activeUrl = new URL(location.href);
      for (const key of ['preview_theme_id', '_fd', 'pb']) {
        if (activeUrl.searchParams.has(key)) sectionUrl.searchParams.set(key, activeUrl.searchParams.get(key));
      }
      sectionUrl.searchParams.set('section_id', 'sm-quick-view');
      const key = sectionUrl.href;
      let markup = cache.get(key);
      if (!markup) {
        const response = await fetch(key, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product request failed');
        markup = await response.text();
        if (!markup) throw new Error('Empty product response');
        cache.set(key, markup);
      }
      if (seq !== requestId || !dialog.open) return;
      const documentResult = new DOMParser().parseFromString(markup, 'text/html');
      const content = documentResult.querySelector('[data-sm-quickview-content]');
      if (!content || !content.querySelector('.sm-qv__details')) throw new Error('Product details missing');
      body.replaceChildren(document.importNode(content, true));
      dialog.removeAttribute('aria-label');
      const selector = body.querySelector('[data-sm-qv-variant]');
      selector?.addEventListener('change', () => {
        const selected = selector.selectedOptions[0];
        const price = body.querySelector('[data-sm-qv-price]');
        if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
        const add = body.querySelector('[data-sm-qv-add]');
        if (add) add.disabled = selected?.dataset.available !== 'true';
      });
    } catch (error) {
      if (error.name !== 'AbortError' && seq === requestId && dialog.open) showFallback(productUrl);
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest?.('[data-sm-quickview-url]');
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    openQuickView(target.getAttribute('data-sm-quickview-url'));
  }, true);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-sm-qv-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => { controller?.abort(); ++requestId; body.replaceChildren(); });
})();
